import { render, staticRenderFns } from "./ClaimsAccordion.vue?vue&type=template&id=117beac8&scoped=true"
import script from "./ClaimsAccordion.vue?vue&type=script&lang=ts"
export * from "./ClaimsAccordion.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsAccordion.vue?vue&type=style&index=0&id=117beac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117beac8",
  null
  
)

export default component.exports